// extracted by mini-css-extract-plugin
export var container = "clone-table-module--container--600c9";
export var row = "clone-table-module--row--0e80e";